// Shared helpers for displaying quote amounts as POST-tax totals (what the
// customer sees on the PDF) without each call site re-importing the math.
//
// Storage stays pre-tax: jobs.quote_amount_cents is the engine subtotal.
// The tax rate is PER-JOB (jobs.quote_tax_rate_pct_snapshot, migration 0048),
// NOT a company-wide setting — sales tax was removed going forward, so new
// jobs carry rate 0 while legacy jobs keep the rate they were quoted at.
//
// Every function takes the job's rate explicitly. The default of 0 is the
// correct value for any surface that shows only going-forward operational
// jobs (today's jobs, open quotes, notifications) — those are tax-free.
// Surfaces that render the legacy completed jobs (jobs list, customer jobs,
// job detail) MUST pass job.quoteTaxRatePctSnapshot so old totals are exact.

import {
  formatCents,
  computeQuoteTotalCents,
  postTaxToSubtotalCents,
} from './format.js';

export function useQuoteFormat() {
  return {
    /** Format a stored (pre-tax) subtotal as the post-tax customer total. */
    formatTotal: (
      subtotalCents: number | null | undefined,
      taxRatePct = 0,
    ): string => formatCents(computeQuoteTotalCents(subtotalCents, taxRatePct)),
    /** Convert a typed post-tax total into the pre-tax subtotal to store. */
    toSubtotalCents: (postTaxCents: number, taxRatePct = 0): number =>
      postTaxToSubtotalCents(postTaxCents, taxRatePct),
    /** Compute the post-tax total as raw cents. */
    toTotalCents: (
      subtotalCents: number | null | undefined,
      taxRatePct = 0,
    ): number => computeQuoteTotalCents(subtotalCents, taxRatePct),
  };
}
